<template>
  <div class="footer-card">
    <!-- 下载遮罩层 -->
    <div v-if="isDownloading" class="download-mask">
      <div class="mask-content">
        <i class="el-icon-loading"></i>
        <p>正在下载中，请稍候...</p>
      </div>
    </div>

    <div class="action-buttons">
      <el-button @click="downloadClick" :loading="isDownloading">下载</el-button>
    </div>
  </div>
</template>

<script>
import { downloadDetailData } from '@/api/RuralFinance'
import { downloadZipFlow } from '@/utils/downloadUtil'

export default {
  name: 'FooterCard',
  props: {
    subjectInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isDownloading: false
    }
  },
  methods: {
    async downloadClick() {
      let identityId = this.subjectInfo.identityId
      let identityType = this.subjectInfo.identityType
      if (!identityId) {
        this.$message.error('用户数据不全，无法下载，请联系管理员')
        return
      }

      try {
        this.isDownloading = true
        let params = { identityId, identityType }
        console.log(params, '下载参数 ')
        let res = await downloadDetailData(params)
        await downloadZipFlow(res)
      } catch (error) {
        console.error('下载失败:', error)
        this.$message.error('下载失败，请重试')
      } finally {
        this.isDownloading = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
// 变量定义 - 从设计稿提取
@primary-color: #2563eb; // 主色调
@text-primary: #1f2937; // 主文本色
@white: #ffffff; // 白色背景
@border-radius: 6px; // 圆角
@box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05); // 阴影

.footer-card {
  width: 100%;
}

// 下载遮罩层样式
.download-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;

  .mask-content {
    background-color: @white;
    border-radius: @border-radius;
    padding: 30px;
    text-align: center;
    box-shadow: @box-shadow;

    i {
      font-size: 32px;
      color: @primary-color;
      margin-bottom: 16px;
      display: block;
      animation: rotating 2s linear infinite;
    }

    p {
      font-size: 16px;
      color: @text-primary;
      margin: 0;
    }
  }
}

@keyframes rotating {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

// 操作按钮区
.action-buttons {
  display: flex;
  gap: 16px;
  justify-content: flex-end;

  .el-button {
    padding: 10px 24px;
    font-size: 16px;

    &.el-button--primary {
      background-color: @primary-color;
      border-color: @primary-color;

      &:hover {
        background-color: darken(@primary-color, 10%);
        border-color: darken(@primary-color, 10%);
      }
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .action-buttons {
    flex-direction: column;

    .el-button {
      width: 100%;
    }
  }
}
</style>
